<template>
  <div class="icon-wrapper flex-inline">
    <FacebookCircleFill role="button" title="Share to Facebook" class="pointer" @click="shareFacebook()" />
    <TwitterFill role="button" title="Share to Twitter" class="pointer" @click="shareTwitter()" />
    <MaillFill role="button" title="Share via Email" class="pointer" @click="shareEmail()" />
  </div>
</template>

<script setup lang="ts">
const config = useRuntimeConfig();
const route = useRoute();

const props = defineProps({
  shareText: {
    type: String,
    required: true,
  },
});

function shareFacebook() {
  const url = `https://www.facebook.com/sharer/sharer.php?u=${(config.public.baseUrl + route.path) as string}`;
  window.open(url, 'FacebookWindow');
}
function shareTwitter() {
  const url = `https://twitter.com/intent/tweet?url=${
    (config.public.baseUrl + route.path) as string
  }&via=getboldify&text=${props.shareText}`;
  window.open(url, 'TwitterWindow');
}
function shareEmail() {
  const url = `mailto:?subject=${props.shareText}&body=${(config.public.baseUrl + route.path) as string}`;
  window.open(url, 'Window');
}
</script>
<style lang="scss" scoped>
.icon-wrapper {
  gap: 5px;
  margin-bottom: 1rem;
}
</style>
